import React, {useState} from 'react';
import SwissCross from './SwissCross';
import LegalModal from './LegalModal';
import {impressum, datenschutz} from '../data/legal';

const docs = {
  impressum: {title: 'Impressum', sections: impressum},
  datenschutz: {title: 'Datenschutzerklärung', sections: datenschutz}
};

// Footer mit funktionalem Impressum und Datenschutz
function Footer() {
  const [open, setOpen] = useState(null);
  const btn = 'hover:text-white focus:outline-none focus-visible:underline';

  return (
    <footer className="bg-[#111827] py-10 text-sm text-gray-400">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 sm:flex-row">
        <p className="flex items-center gap-2">
          <SwissCross className="h-6 w-6" />
          © {new Date().getFullYear()} Praxisratgeber Schweiz · Marc Arndt
        </p>
        <nav aria-label="Rechtliches" className="flex gap-5">
          <button type="button" onClick={() => setOpen('impressum')} className={btn}>Impressum</button>
          <button type="button" onClick={() => setOpen('datenschutz')} className={btn}>Datenschutz</button>
        </nav>
      </div>
      {open && (
        <LegalModal
          title={docs[open].title}
          sections={docs[open].sections}
          onClose={() => setOpen(null)}
        />
      )}
    </footer>
  );
}

export default Footer;